module.exports = __webpack_public_path__ + "static/media/icon_sync_alt.9109edc8.svg";